export enum MapStyle {
  HYBRID = 'satellite_road_labels',
  SATELLITE = 'satellite',
  ROADMAP = 'road',
  NIGHT = 'night',
}
